<template>
  <v-app-bar app clipped-left color="primary" dark class="b-app-bar">
    <v-app-bar-nav-icon @click.native.stop="$emit('toggle')">
      <v-icon>mdi-apps</v-icon>
    </v-app-bar-nav-icon>

    <v-toolbar-title>
      <router-link :to="homeRoute" class="b-app-bar__link" v-text="title" />
    </v-toolbar-title>

    <BMenuHeaderList :menu-list="menuListAdmin" style="padding-left: 40px;" />

    <v-spacer />

    <BProfileCard
      v-if="!profiless"
      :profile="profile"
      style="max-width: 240px;"
    />

    <slot name="notifications" />

    <BTooltipButton
      class-button="ml-4"
      icon="mdi-exit-to-app"
      tooltip="Выйти"
      left
      :to="logoutRoute"
    />
  </v-app-bar>
</template>

<script>
import { AUTH_ROUTES } from '@/views/Auth/utils'
import { HOME_ROUTES } from '@/views/Home/utils'
import * as MENU_FOLDERS from '@/helpers/enums/menu-folders'
import { getProjectName } from '@/helpers/projectName'
import { collectorViewPermissions as CollectorPermissions, marksViewPermissions as MarksPermissions } from '@/helpers/enums/permission-models'

import BTooltipButton from '@/components/common/BTooltipButton.vue'
import BProfileCard from './components/BProfileCard.vue'
import BMenuHeaderList from './components/BMenuHeaderList.vue'

export default {
  name: 'BAppBar',
  components: {
    BTooltipButton,
    BProfileCard,
    BMenuHeaderList,
  },
  props: {
    profiless: Boolean,
    profile: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    homeRoute: { name: HOME_ROUTES.INDEX },
    title: getProjectName(),
    logoutRoute: { name: AUTH_ROUTES.LOGOUT },
  }),
  computed: {
    menuListAdmin() {
      const result = [
        MENU_FOLDERS.ADMIN_AUTH,
        MENU_FOLDERS.ADMIN_LK,
      ]

      {
        const canEdit = this.$access(CollectorPermissions.edit, false)
        const canRead = this.$access(CollectorPermissions.read, false)
        if (canEdit && canRead) {
          result.push(
            MENU_FOLDERS.ADMIN_COLLECTOR,
          )
        }
      }

      {
        const canEdit = this.$access(MarksPermissions.edit, false)
        const canRead = this.$access(MarksPermissions.read, false)
        if (canEdit && canRead) {
          result.push(
            MENU_FOLDERS.ADMIN_MARKS,
          )
        }
      }
      return result.map(this.handleMenu)
    },
  },
  methods: {
    handleMenu(menu) {
      if (!menu.route) return menu

      try {
        const { resolved } = this.$router.resolve(menu.route)
        const disabled = menu.disabled || resolved.matched.length === 0
        return { ...menu, disabled }
      } catch {
        return menu
      }
    },
  },
}
</script>

<style lang="scss">
.b-app-bar {
  &__link {
    color: inherit !important;
    text-decoration-line: none;

    &.router-link-exact-active {
      pointer-events: none;
    }
  }
}
</style>
